import * as React from "react";
import classNames from "classnames";

import "./Button.scss";

interface Button {
  type?: "submit" | "button" | "reset";
  buttonType?: "primary" | "secondary" | "tertiary";
  className?: string;
  disabled?: boolean;
  onClick?: () => any;
  children: React.ReactNode;
}

const Button: React.FC<Button> = (props: Button) => {
  const {
    type = "button",
    buttonType = "primary",
    className,
    disabled = false,
    onClick,
    children,
  } = props;

  const buttonClasses = classNames(
    "w-full sm:w-2/3 sm:mx-auto sm:block md:w-auto md:mr-0 px-4 py-2 text-s font-bold hover:bg-dw-blue hover:text-white",
    {
      "bg-dw-bright-blue text-dw-blue": buttonType === "primary",
      "bg-dw-grey-03 text-dw-blue": buttonType === "secondary",
      "bg-white text-dw-blue border border-dw-grey-06":
        buttonType === "tertiary",
      [`${className}`]: className,
      "bg-dw-grey-02 pointer-events-none text-dw-grey-11 line-through": disabled,
    }
  );

  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={buttonClasses}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
